module.exports = __webpack_public_path__ + "static/media/manageCampaign-loading.d52b5b02.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/campaigns/manageCampaign-loading.png
// module id = 1030
// module chunks = 0